import { render, staticRenderFns } from "./PasswordFindCertifyDone.vue?vue&type=template&id=d6ed7c10&scoped=true"
import script from "./PasswordFindCertifyDone.vue?vue&type=script&lang=js"
export * from "./PasswordFindCertifyDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ed7c10",
  null
  
)

export default component.exports